export default __webpack_public_path__ + "static/media/placeholder2.08a931a9.jpg";